import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { orpc } from "@/lib/orpc";
import { InstitutionsCard } from "./-components/care-network/institutions-card";

export const Route = createFileRoute("/_authenticated/_care/residents/$residentId/institutions")({
  component: InstitutionsTab,
});

function InstitutionsTab() {
  const { residentId } = Route.useParams();
  const { data: resident } = useSuspenseQuery(
    orpc.care.residents.get.queryOptions({ input: { residentId } }),
  );
  return (
    <InstitutionsCard
      owner={{ kind: "resident", id: residentId }}
      facilityId={resident.facilityId}
    />
  );
}
